import { Liquid } from 'liquidjs'
import { useEffect, useState } from 'react'

const engine = new Liquid()

export function useLiquidPreview(template: string, data?: Record<string, unknown>) {
  const [html, setHtml] = useState('')
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    if (!template.trim()) {
      setHtml('')
      setError(null)
      return
    }

    let cancelled = false

    engine
      .parseAndRender(template, data ?? {})
      .then((result) => {
        if (!cancelled) {
          setHtml(result)
          setError(null)
        }
      })
      .catch((err: unknown) => {
        if (!cancelled) {
          setError(err instanceof Error ? err.message : String(err))
        }
      })

    return () => {
      cancelled = true
    }
  }, [template, data])

  return { html, error }
}
